import frontend from '../assets/frontend.jpg'
import webDev from '../assets/webdev.webp'
import dataAnalysis from '../assets/data-analysis.webp'
import { ProgrammeType } from '../types'
import { learningInterests } from './courses'
import { getCourseRegistrationLink } from '../utils/getLearningPath'
export const SHORT_COURSES_APPLICATION_FORM_URL =
  'https://forms.gle/p88eqjXkTj2geErdA'

export const shortCourses: ProgrammeType[] = [
  {
    title: 'Intro to Web Dev',
    description: `Learn the fundamentals of web development, including HTML, CSS, JavaScript, and problem-solving skills. Create responsive designs, write clean code, and more!
        `,
    learningOutcomes: [
      'Introduction to computer programming',
      'HTML & CSS 🎨',
      'JavaScript',
      'Version Control (Git) 📄',
      'Problem-solving 🧩',
      'And much more!',
    ],
    link: SHORT_COURSES_APPLICATION_FORM_URL,
    duration: '3 Months (FREE)',
    image: webDev,
    key: learningInterests.web,
  },
  {
    title: 'Data Analysis with Excel',
    description: `Learn data analysis with Excel, including data cleaning, data visualization, and statistical analysis. Master Excel, SQL, Git, and more! 📊`,
    learningOutcomes: [
      'Excel 📊',
      'SQL 🗄️',
      'Data Visualization 📈',
      'Statistical Analysis 📊',
      'And much more!',
    ],
    link: SHORT_COURSES_APPLICATION_FORM_URL,
    duration: '3 Months (FREE)',
    image: dataAnalysis,
    key: learningInterests.excelDataAnalysis,
  },
  {
    title: 'React Frontend Dev',
    description: `Master ReactJS, the most popular JavaScript library for building user interfaces. Learn React Hooks, Context, Next.js, Redux, and more! ⚛️`,
    learningOutcomes: [
      'React.js ⚛️',
      'React Hooks',
      'React Context',
      'Redux',
      'Next.js',
      'React Testing Library and Jest',
    ],
    link: getCourseRegistrationLink(learningInterests.reactFrontend),
    duration: '1 - 2 Months',
    image: frontend,
    key: learningInterests.reactFrontend,
  },
  {
    title: 'Data Analysis with Python',
    description: `Learn data analysis with Python, including data cleaning, data visualization, and statistical analysis. Master Python, SQL, Git, and more! 📊`,
    learningOutcomes: [
      'Python 🐍',
      'SQL 🗄️',
      'Data Visualization 📊',
      'Statistical Analysis 📈',
      'And much more!',
    ],
    link: getCourseRegistrationLink(learningInterests.pythonDataAnalysis),
    duration: '3 Months',
    image: dataAnalysis,
    key: learningInterests.pythonDataAnalysis,
  },
  {
    title: 'Node.js Backend Dev',
    description: `Master Node.js, Express, and MongoDB. Learn to build scalable and secure backend applications. 🚀`,
    learningOutcomes: [
      'Node.js',
      'Express',
      'MongoDB',
      'API Development',
      'Security',
      'Scalability',
    ],
    link: getCourseRegistrationLink(learningInterests.nodeBackend),
    duration: '1 - 2 Months',
    image: webDev,
    key: learningInterests.nodeBackend,
  },
  {
    title: 'Python Backend Dev',
    description: `Master Python, and frameworks like Django. Learn database design, API development, security, scalability, and more.`,
    learningOutcomes: [
      'Python',
      'Django',
      'Database Design and Management 🗄️',
      'API Development',
      'Security',
      'And much more!',
    ],
    link: getCourseRegistrationLink(learningInterests.pythonBackend),
    duration: '1 - 2 Months',
    image: webDev,
    key: learningInterests.pythonBackend,
  },
  {
    title: 'Java Backend Dev',
    description: `Master Java, and Spring Boot. Learn database design, API development, and how to build scalable and secure backend applications.`,
    learningOutcomes: [
      'Java',
      'Spring Boot',
      'MySQL',
      'API Development',
      'Security',
      'Scalability',
    ],
    link: getCourseRegistrationLink(learningInterests.javaBackend),
    duration: '1 - 2 Months',
    image: webDev,
    key: learningInterests.javaBackend,
  },
  {
    title: 'Software Engr. Essentials',
    description: `Master software engineering essentials, including version control, software development life cycle (SDLC), agile methodologies, solid principles, etc.`,
    learningOutcomes: [
      'Version Control',
      'Software Development Life Cycle',
      'Agile Methodologies',
      'Solid Principles',
      'Design Patterns',
      'Accessibility',
      'Object-Oriented Programming',
      'And much more!',
    ],
    link: getCourseRegistrationLink(
      learningInterests.softwareEngineeringEssentials,
    ),
    duration: '1 - 2 Months',
    image: webDev,
    key: learningInterests.softwareEngineeringEssentials,
  },
]
